import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['output'];
  static requiredTargets = [];
  static values = {
    instanceid: String,
    apikey: String,
    jsurl: String,
    locale: String
  };

  // TARGETS
  declare outputTarget: HTMLDivElement;
  declare readonly hasOutputTarget: boolean;

  // VALUES
  declare jsurlValue: string;
  declare instanceidValue: string;
  declare apikeyValue: string;
  declare localeValue: string;

  initialize() {
    this.renderOlapicControl();
  }

  renderOlapicControl() {
    if (this.hasOutputTarget) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = this.jsurlValue;
      s.setAttribute('data-instance', this.instanceidValue);
      s.setAttribute('data-apikey', this.apikeyValue);
      s.setAttribute('data-lang', this.localeValue);
      s.setAttribute('data-olapic', this.outputTarget.id);
      this.element.appendChild(s);
    }
  }
}
